export default __webpack_public_path__ + "static/media/tolandscape.66dff349.svg";